import { Link } from 'react-router-dom'
import img1 from '../images/about-7-copyright.jpg'

function Contact() {
	return (
		<>

<section class="hero_area cu_area" style={{background:`URL(${img1})`}}>
		<div class="container">
			<div class="hero_cnt">
				<div class="hero_title">
					<h2>Contact Us</h2>
					<h1> Contact Us – BlueLakeEscapesFI</h1>
					<p>Welcome to the Contact Us page of BlueLakeEscapesFI! We are here to assist you with any questions, concerns, or feedback you may have regarding our fantasy cricket platform.</p>
					<h2> Get in Touch</h2>
					<p>Whether you need help with registration, have inquiries about the Balls System, or want to share your thoughts about our services, our dedicated support team is ready to help!</p>
					<p>
						<a href="#">+497312543602</a>
					</p>
					<p>
						<a href="#">info@BlueLakeEscapesFI.com</a>
					</p>
				</div>
			</div>
		</div>
	</section>

	<section class="sec_2_cu">
		<div class="container">
			<form action="">
				<div class="s2_cu_cnt">
					<div class="s2_cu_title">
						<h3>Contact Us</h3>
					</div>
					<div class="form_input">
						<label for="name">Name</label>
						<input type="text"/>
					</div>
					<div class="form_input">
						<label for="name">Email</label>
						<input type="email"/>
					</div>
					<div class="form_input">
						<label for="name">Message</label>
						<textarea name="" id="" row="7" cell="7"></textarea>
					</div>
					<div class="form_input_s">
						<input type="submit" value="Send Message"/>
					</div>
				</div>
			</form>
		</div>
	</section>



		</>
	)
}

export default Contact
